import PropTypes from 'prop-types';

import useAnyField from '../hooks/useAnyField';


function HiddenField({ name, value }) {
    // The hook takes care of ALL state/lifecycle management.
    useAnyField({ name, value });
    
    // NO effect on the DOM. We just mutate the Form we're a member of.
    return null;
}

HiddenField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
};

HiddenField.defaultProps = {
    value: undefined,
};

export default HiddenField;
